<template>
  <div class="mt-8" v-if="loading">
    <loading />
  </div>
  <div
    class="w-full mt-20 p-8 stack text-center"
    v-else-if="
      displayCurrent && (!targetInvitationTargets || targetInvitationTargets.length < 1) &&
        (!sortedTargets || sortedTargets < 1) && (!unstartedTargets || unstartedTargets.length < 1)
    "
  >
    <div>
      <icon name="WaldigLogo" size="3.5em" :settings="{ strokeWidth: 0.8 }" />
    </div>
    <div class>{{ $t("targets.no_targets_yet") }}</div>
    <info
      class="mt-4"
      toggleable
      :title="$t('targets.add_target')"
    >{{ $t("targets.add_targets_info") }}</info>
    <fab @input="openCreateTarget">
      <icon name="Plus" />
    </fab>
  </div>
  <div v-else>
    <div
      v-if="
        targetInvitationActivities &&
          targetInvitationTargets &&
          targetInvitationTargets.length > 0
      "
    >
      <target
        v-for="target in targetInvitationTargets"
        :key="target.id"
        :target="target"
        :invitation="getInvitationId(target.id)"
        :activity="getTargetInvitationActivity(target.activity_id)"
      />
    </div>
    <div v-if="displayCurrent">
      <target
        v-for="target in sortedTargets"
        :key="target.id"
        :target="target"
        :activity="getTargetActivity(target.activity_id)"
      />
      <target
        v-for="target in unstartedTargets"
        :key="target.id"
        :target="target"
        unstarted
        :activity="getTargetActivity(target.activity_id)"
      />
    </div>
    <div v-else>
      <target
        v-for="target in finishedTargets"
        :key="target.id"
        :target="target"
        finished
        :activity="getTargetActivity(target.activity_id)"
      />
      <target
        v-for="target in failedTargets"
        :key="target.id"
        :target="target"
        failed
        :activity="getTargetActivity(target.activity_id)"
      />
    </div>
    <fab @input="openCreateTarget">
      <icon name="Plus" />
    </fab>
  </div>
</template>

<script>
const Target = require("@/modules/targets/components/Target.vue").default;
const Fab = require("@/modules/core/components/Fab.vue").default;
const Info = require("@/modules/core/components/Info.vue").default;

import { Target as TargetModel } from "@/modules/targets/viewmodels/Target";
import { ActivityModel } from "@/modules/activities/viewmodels/Activity";
import moment from "moment";
import _ from "lodash";

export default {
  name: "TargetsSite",
  data() {
    return {
      displayCurrent: true
    };
  },
  props: {},
  components: {
    Target,
    Fab,
    Info
  },
  methods: {
    openCreateTarget() {
      this.$router.push("/create-target");
    },
    getTargetActivity(ActivityId) {
      return this.activities
        ? new ActivityModel(this.activities.find(e => e.id === ActivityId))
        : false;
    },
    getTargetInvitationActivity(ActivityId) {
      return this.targetInvitationActivities
        ? new ActivityModel(
            this.targetInvitationActivities.find(e => e.id === ActivityId)
          )
        : false;
    },
    getInvitationId(TargetId) {
      let invitation = this.targetInvitations.find(
        e => e.target_id === TargetId
      );
      return invitation ? invitation.id : false;
    }
  },
  computed: {
    ongoingTargets() {
      return this.$store.getters["target/ongoingTargets"];
    },
    finishedTargets() {
      return this.$store.getters["target/finishedTargets"];
    },
    failedTargets() {
      return this.$store.getters["target/failedTargets"];
    },
    unstartedTargets() {
      return this.$store.getters["target/unstartedTargets"];
    },
    targetInvitations() {
      return this.$store.getters["targetinvitation/targetInvitations"];
    },
    targetInvitationTargets() {
      return this.targetInvitations && this.targetInvitations.length > 0
        ? this.targetInvitations.map(e => new TargetModel(e.target))
        : false;
    },
    targetInvitationActivities() {
      return this.targetInvitations
        ? this.targetInvitations.map(e => e.target.activity)
        : false;
    },
    activities() {
      return this.$store.getters["activity/activities"];
    },
    sortedTargets() {
      return _.orderBy(this.ongoingTargets, "end");
    }
  },
  async created() {
    await this.$store.getters["target/api"].Custom.My();
    await this.$store.getters["targetinvitation/api"].Custom.My();
    await this.$store.getters["activity/api"].Custom.AllMy();
    this.$store.dispatch("header/updateTab", 0);
    this.$store.dispatch("header/update", {
      elements: [
        {
          type: "icon",
          value: "WaldigLogo",
          location: "left",
          iconSettings: { size: "1.8em", circle: true },
          action: () => {}
        },
        {
          type: "text",
          css: "tracking-wider",
          value: this.$tc("targets.target", 2),
          location: "left"
        }
      ],
      tabs: {
        elements: [
          {
            bright: true,
            title: this.$t("targets.ongoing"),
            action: () => {
              this.displayCurrent = true;
            }
          },
          {
            bright: true,
            title: this.$t("targets.past"),
            action: () => {
              this.displayCurrent = false;
            }
          }
        ]
      }
    });
    this.loaded();
  }
};
</script>
